// =============================================================================
// src/features/analytics/analytics-insights-edition-loader.ts - Carga sob
// demanda do CORPO de uma edicao (clique prev/next). Espelho fiel do
// analytics-actor-feed-store: o composition root registra o loader quando o
// live esta habilitado; sem ele (mock/offline) devolve null e o controller
// decide o toast. SRP: registro + despacho, sem estado de navegacao.
// =============================================================================

import type { AnalyticsInsightDocKind, AnalyticsInsightEditionRef } from './analytics-insights-types';

/** Corpo carregado; docKind vem da LINHA do banco (autoritativo — a ref da
 * lista pode ter envelhecido entre as duas queries). */
export interface AnalyticsInsightEditionBodyLoad {
  readonly markdownBody: string;
  readonly docKind: AnalyticsInsightDocKind;
}

type AnalyticsInsightEditionBodyLoader = (
  editionRef: AnalyticsInsightEditionRef,
) => Promise<AnalyticsInsightEditionBodyLoad | null>;

let insightEditionBodyLoader: AnalyticsInsightEditionBodyLoader | null = null;

/** Registrado pelo main.ts quando o Analytics live esta habilitado. */
export function setAnalyticsInsightEditionBodyLoader(loader: AnalyticsInsightEditionBodyLoader): void {
  insightEditionBodyLoader = loader;
}

/** Busca o corpo; null em indisponivel/falha (controller decide o toast). */
export async function loadAnalyticsInsightEditionBody(
  editionRef: AnalyticsInsightEditionRef,
): Promise<AnalyticsInsightEditionBodyLoad | null> {
  if (!insightEditionBodyLoader) return null;
  try {
    return await insightEditionBodyLoader(editionRef);
  } catch {
    return null;
  }
}

export function __resetAnalyticsInsightEditionLoaderForTests(): void {
  insightEditionBodyLoader = null;
}
